import ko from 'knockout';

(ko.extenders as any).numeric = function(target, precision) {
    //create a writable computed observable to intercept writes to our observable
    var result = ko.pureComputed({
        read: target,  //always return the original observables value
        write: function(newValue:number) {
            var current = target(),
                roundingMultiplier = Math.pow(10, precision),
                newValueAsNum = isNaN(newValue) ? 0 : +newValue,
                valueToWrite = Math.round(newValueAsNum * roundingMultiplier) / roundingMultiplier;

            //only write if it changed
            if (valueToWrite !== current) {
                target(valueToWrite);
            } else {
                //if the rounded value is the same, but a different value was written, force a notification for the current field
                if (newValue !== current) {
                    target.notifySubscribers(valueToWrite);
                }
            }
        }
    }).extend({ notify: 'always' });

    //initialize with current value to make sure it is rounded appropriately
    result(target());

    //return the new computed observable
    return result;
};


ko.bindingHandlers.currency = {
    update: function(element, valueAccessor){
        // retrieve observable value
        var value = ko.utils.unwrapObservable(valueAccessor()) || 0;
        //convert to number of string
        value = + value;
        //format currency
        var formattedText =  "£" + value.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
        //apply formatted text to the underlying DOM element
        $(element).text(formattedText);
    }
};      